import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import { useSite } from '../lib/content';

const Footer = () => {
  const site = useSite();
  const f = site.footer || {};
  const nav = (Array.isArray(site.nav) ? site.nav : []).filter((n) => n.to !== '/');
  const social = site.social || {};

  return (
    <footer className="bg-[#942222] text-[#f1ead9]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-24 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-5">
            <Logo size={64} />
            <p className="mt-8 font-serif text-2xl leading-snug text-[#f1ead9] max-w-md">
              {f.tagline}
            </p>
          </div>

          <div className="lg:col-span-3">
            <p className="font-serif text-xl leading-snug">{f.addressLine1}<br/>{f.addressLine2}</p>
            <a href={`tel:${site.phoneRaw}`} className="block mt-6 font-serif text-xl hover:opacity-70 transition">
              {site.phone}
            </a>
            <p className="mt-6 text-[12px] tracking-[0.18em] uppercase opacity-70 whitespace-pre-line leading-relaxed">{f.hoursLabel}</p>
          </div>

          <div className="lg:col-span-2 flex flex-col gap-3 text-[14px]">
            {nav.map((n) => (
              <Link key={n.to} to={n.to} className="hover:opacity-70 transition">{n.label}</Link>
            ))}
          </div>

          <div className="lg:col-span-2 flex flex-col gap-3 text-[14px]">
            <a href={`mailto:${site.email}`} className="hover:opacity-70 transition">{site.email}</a>
            {social.instagram && <a href={social.instagram} target="_blank" rel="noreferrer" className="hover:opacity-70 transition">Instagram</a>}
            {social.facebook && <a href={social.facebook} target="_blank" rel="noreferrer" className="hover:opacity-70 transition">Facebook</a>}
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-[#f1ead9]/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-[11px] tracking-[0.22em] uppercase opacity-70">
            {f.copyright}
          </p>
          <a
            href="mailto:info@bellajaelectric.com"
            data-testid="footer-created-by"
            className="text-[11px] tracking-[0.22em] uppercase opacity-70 hover:opacity-100 transition"
          >
            Created by Bellaja
          </a>
          <p className="text-[11px] tracking-[0.22em] uppercase opacity-70">
            {f.badge}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
